module.exports = __webpack_public_path__ + "img/accepted.0c3246dd.svg";